import { MantineProvider } from '@mantine/core';
import { DatesProvider } from '@mantine/dates';
import { Notifications } from '@mantine/notifications';
import { QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from '@zenos/front-end-auth';
import { AppProvider } from '@zenos/front-end-context';
import { ability, AbilityProvider } from '@zenos/front-end-ui-ability';
import { theme } from '@zenos/front-end-ui-theme';
import { queryClient } from '@zenos/front-end-util-utils';
import 'dayjs/locale/en-gb';
import type { ReactNode } from 'react';
export const Providers = ({ children }: { children: ReactNode }) => (
  <MantineProvider theme={theme}>
    <Notifications zIndex={1000}></Notifications>
    <DatesProvider settings={{ locale: 'en-gb' }}>
      <AuthProvider>
        <QueryClientProvider client={queryClient}>
          <AppProvider>
            <AbilityProvider value={ability}>{children}</AbilityProvider>
          </AppProvider>
        </QueryClientProvider>
      </AuthProvider>
    </DatesProvider>
  </MantineProvider>
);
